import React, { Component } from "react";
import { utils } from "@mc/mc-legacy";
import { connect } from "react-redux";
import * as fieldActions from "../../actions/fieldActions";
import MultiSelect from "../MultiSelect";
/**
 * field pro filtr předkladatelů
 */

class RequestPersonFilterField extends Component {
  componentDidMount() {
    this.fetchData(this.props, true);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.fetchData(nextProps, false);
  }

  fetchData = (props, forceFetch) => {
    const { dispatch } = props;
    dispatch(fieldActions.findAllPersons(forceFetch));
  };

  render() {
    const { typStore, ...componentProps } = this.props;
    return <MultiSelect typStore={typStore} {...componentProps} />;
  }
}

export default connect((state) => {
  return {
    typStore: utils.storeFromArea(state, fieldActions.QSIGN_PERSON_LIST),
  };
})(RequestPersonFilterField);
